/**
 * 현재 탭에서 주어진 URL 로 이동한다.
 *
 * `window.location.href = url` 을 호출부에 직접 쓰지 않고 이 함수를 거치는 이유는
 * **테스트 이음새(seam)** 를 만들기 위해서다. 직접 쓰면 테스트가 전역 `window.location` 을
 * 통째로 갈아끼워야 하는데, 그 속성의 `configurable` 여부는 jsdom 버전에 따라 달라져 온
 * 내부 구현 세부사항이다. 이 함수를 모킹하면 전역을 건드리지 않고 이동을 검증할 수 있다.
 */
export const navigateSameTab = (url: string) => {
  window.location.href = url;
};
